export default "__VITE_ASSET__BnsVzjpX__"